import { render, staticRenderFns } from "./Zonas.vue?vue&type=template&id=4722e8e8"
import script from "./Zonas.vue?vue&type=script&lang=js"
export * from "./Zonas.vue?vue&type=script&lang=js"
import style0 from "./Zonas.vue?vue&type=style&index=0&id=4722e8e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports